import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import { WhatsAppFloating } from "./components/WhatsApp";
import { Toaster } from "./components/ui/toaster";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import WegVerwaltungKleve from "./pages/WegVerwaltungKleve";
import Verwalterwechsel from "./pages/Verwalterwechsel";
import FaqPage from "./pages/FaqPage";
import { TrustBar } from "./components/TrustBar";
import { useSeo } from "./seo";

const Home = () => {
  useSeo("/");
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <About />
        <Services />
        <Benefits />
        <Process />
        <Testimonials />
        <FAQ />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
};

export const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/weg-verwaltung-kleve" element={<WegVerwaltungKleve />} />
    <Route path="/verwalterwechsel" element={<Verwalterwechsel />} />
    <Route path="/faq" element={<FaqPage />} />
    <Route path="/impressum" element={<Impressum />} />
    <Route path="/datenschutz" element={<Datenschutz />} />
  </Routes>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
